import { RefObject, useEffect } from 'react';

type UsePointerDownOutsideParams = {
    ref: RefObject<HTMLElement>;
    handler: (event: PointerEvent) => void;
    enabled?: boolean;
};

const usePointerDownOutside = ({ ref, handler, enabled = true }: UsePointerDownOutsideParams) => {
    useEffect(() => {
        if (!enabled) return;
        if (typeof window === 'undefined') return;

        const listener = (event: PointerEvent) => {
            const element = ref.current;
            if (!element) return;
            if (element.contains(event.target as Node)) return;
            handler(event);
        };

        window.addEventListener('pointerdown', listener);
        return () => {
            window.removeEventListener('pointerdown', listener);
        };
    }, [enabled, handler, ref]);
};

export { usePointerDownOutside };
